import { combineReducers } from 'redux'
import userContextReducer from './userContextReducer'
import layoutReducer from './layoutReducer'
import navbarReducer from './navbarReducer'
import chatbotReducer from './chatbotReducer'
import reportsReducer from './reportsReducer'
import databoxReducer from './databoxReducer'

const rootReducer = combineReducers({
  layoutReducer,
  navbarReducer,
  userContextReducer,
  chatbotReducer,
  reportsReducer,
  databoxReducer
})

export default rootReducer
